import { useMemo, useState } from "react";
import LabelPicker from "../LabelPicker";
import { getDefaultPreset } from "../../lib/labels";

export type LabelSheetPanelProps = {
  hasLicense: boolean;
  busy: boolean;
  frameSelected: boolean;
  selectedLabelKey: string | null;
  onChangeSelectedLabelKey: (key: string) => void;
  onResetDefault: () => void;
  onGenerate: (opts: { presetKey: string; innerPaddingPct: number; startPosition: number; includeCaption: boolean }) => void;
};

export default function LabelSheetPanel({ hasLicense, busy, frameSelected, selectedLabelKey, onChangeSelectedLabelKey, onResetDefault, onGenerate }: LabelSheetPanelProps) {
  const [enabled, setEnabled] = useState(false);
  const [innerPaddingPct, setInnerPaddingPct] = useState(0.06);
  const [startPosition, setStartPosition] = useState(1);
  const [includeCaption, setIncludeCaption] = useState(false);
  const effectiveKey = useMemo(() => selectedLabelKey || getDefaultPreset(frameSelected ? "framed" : "square").key, [selectedLabelKey, frameSelected]);

  return (
    <div className={hasLicense ? "" : "opacity-55"}>
      <div className="flex items-center gap-2 min-h-11">
        <input 
          type="checkbox" 
          checked={enabled && hasLicense} 
          onChange={(e) => setEnabled(e.target.checked)} 
          disabled={!hasLicense} 
          className="h-4 w-4"
        />
        <span className="text-sm">Build label sheets (PDF) — Pro</span>
      </div>

      {enabled && (
        <div className="mt-4 space-y-4">
          <LabelPicker
            frameSelected={frameSelected}
            selectedKey={selectedLabelKey}
            onChange={(k) => onChangeSelectedLabelKey(k)}
            onReset={onResetDefault}
          />

          {/* Inner padding control hidden for now; keep default value internally */}

          <label className="form-label text-sm">
            <span>Start position</span>
            <input
              type="number"
              min={1}
              value={startPosition}
              onChange={(e) => setStartPosition(parseInt(e.target.value || "1", 10))}
              className="form-input"
            />
          </label>

          <label className="flex items-center gap-2 min-h-11 text-sm">
            <input 
              type="checkbox" 
              checked={includeCaption} 
              onChange={(e) => setIncludeCaption(e.target.checked)}
              className="h-4 w-4" 
            />
            <span>Include caption</span>
          </label>

          <div className="mt-4">
            <button
              onClick={() => onGenerate({ presetKey: effectiveKey, innerPaddingPct, startPosition: Math.max(1, startPosition | 0), includeCaption })}
              disabled={!enabled || busy}
              className="btn btn-primary disabled:cursor-not-allowed"
            >
              {busy ? "Working…" : "Generate Labels PDF"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}